import axios from "axios";
import { IAPIResponse } from "../../types/IAPIResponse";
import {
  ApplicantsMajorsDto,
  ApplicationMajorOpenDto,
  ApplicationTypeDto,
} from "../../types/Applicant/ApplicationTypeDto";
export class AdminApplicationsAPI {
  async GetAll(term: number): Promise<IAPIResponse<ApplicationTypeDto[]>> {
    const response = await axios.get<IAPIResponse>(
      "admin/applications/ListOfApplications/" + term
    );
    let templetes: IAPIResponse<ApplicationTypeDto[]> = response.data;
    return Promise.resolve(templetes);
  }

  async GetAllMajors(
    applicationId: number
  ): Promise<IAPIResponse<ApplicantsMajorsDto[]>> {
    const response = await axios.get<IAPIResponse>(
      "admin/applications/ListOfMajors/" + applicationId
    );
    let templetes: IAPIResponse<ApplicantsMajorsDto[]> = response.data;
    return Promise.resolve(templetes);
  }

  async UpdateApplication(
    application: ApplicationMajorOpenDto
  ): Promise<IAPIResponse<ApplicationMajorOpenDto>> {
    const response = await axios.put<IAPIResponse>(
      "admin/applications/updateApplication/",
      application
    );
    let templetes: IAPIResponse<ApplicationMajorOpenDto> = response.data;
    return Promise.resolve(templetes);
  }

  async UpdateMajor(
    major: ApplicationMajorOpenDto
  ): Promise<IAPIResponse<ApplicationMajorOpenDto>> {
    const response = await axios.put<IAPIResponse>(
      "admin/applications/updateMajor/",
      major
    );
    let templetes: IAPIResponse<ApplicationMajorOpenDto> = response.data;
    return Promise.resolve(templetes);
  }
}
